export const excelName='商品资料'
export const headerData = ['货主名称','商品编号','商品名称','助记码','英文名','通用名','生产厂家',
  '产地', '批准文号', '批准文号校期', '商品类型', '商品类别', '存储条件', '工位类型', '监管码首字母',
  '监管码长度', '销售分类','存储环境','库存周转方式','存储分类','偏差','近效期天数','近产期天数','复检天数',
  '成本价','零售价','批发价', '是否监管','是否进口药品','是否贵重药品','是否冷链','是否特管','是否双人','是否新品',
  '是否已审核','是否可用']
export const filterVal = ['storer','no','name','mnemonicCode','englishName','universalName','manufacturer',
  'producingArea','approval','approvalValidUntil','itemType','itemCategory','storageRequest','positionType',
  'supervisingBarcodeInitial', 'supervisingBarcodeLength', 'saleClassification', 'storageEnvironment',
  'turnoverMode','storageClassification', 'deviation', 'daysOfExpirationNearly','daysOfProductionNearly','daysOfInspectionNearly',
  'costPrice', 'retailPrice', 'wholesalePrice', 'supervised', 'importation', 'valuable', 'coldChains', 'controlled', 'duplex', 'newProduct',
  'approved','available']